module.exports = __webpack_public_path__ + "img/uxDesign.75812948.svg";